import { ObservableArray, View } from "binder"
import { ReceiptFormViewModel, LineItem } from "./receiptForm-viewModel"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";

export class ReceiptFormView extends View<ReceiptFormViewModel>{
    GetViewUniqueId(): string {
        return "V-16696219-7D88-433F-86E5-81B01F8AF8C1"
    }
    loadHtml(): string {
        let element = require('./receiptForm.html').default;
        let style = require('./receiptForm.less');
        return element;
    }
    constructor() {
       super();
    }
    
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set transferId(v: string) { this._transferId = v; } public get transferId(): string { return this._transferId;} private _transferId: string;
    public set transferType(v: string) { this._transferType = v; } public get transferType(): string { return this._transferType;} private _transferType: string;
    public set destinationLineItems(v: ObservableArray<LineItem>) { this._destinationLineItems = v; } public get destinationLineItems(): ObservableArray<LineItem> { return this._destinationLineItems;} private _destinationLineItems: ObservableArray<LineItem>;
    public set toWarehouseName(v: string) { this._toWarehouseName = v; } public get toWarehouseName(): string { return this._toWarehouseName;} private _toWarehouseName: string;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;

    close() {
        this.dataContext.closePopup();
    }

    receipt() {
        this.dataContext.receipt();
    }
}
